import { fmtNum } from '@/lib/format';
import { Sparkline } from './Sparkline';
import { type StockCategory, fmtCzk, pctTone, splitPath, stockPct } from './types';

type Props = {
  category: StockCategory;
  /** Podíl kategorie na hodnotě celého skladu (0–100). */
  share: number;
  onOpen: () => void;
};

/** Dlaždice kategorie: hodnota bez DPH, pruh variant skladem, graf, ikona seznamu. */
export function CategoryCard({ category: c, share, onOpen }: Props) {
  const { name, parent } = splitPath(c.path);
  const pct = stockPct(c);
  const tone = pctTone(pct);
  return (
    <div className="bg-surface rounded-xl border border-border shadow-card hover:shadow-card-hover transition-shadow p-4 flex gap-3">
      <div className="flex-1 min-w-0">
        <div className="flex items-start gap-2">
          <button
            type="button"
            onClick={onOpen}
            title="Seznam produktů"
            aria-label={`Seznam produktů v kategorii ${name}`}
            className="shrink-0 -ml-1 p-1 rounded-md text-text-secondary hover:text-primary hover:bg-primary-50 cursor-pointer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01" />
            </svg>
          </button>
          <div className="min-w-0">
            {parent && (
              <div className="text-[11px] text-text-muted truncate" title={parent}>
                {parent}
              </div>
            )}
            <div className="text-sm font-semibold text-text truncate" title={c.path}>
              {name}
            </div>
          </div>
        </div>

        <div className="mt-2 flex items-baseline gap-2">
          <span className="text-xl font-bold text-text">{fmtCzk(c.valueNet)}</span>
          <span className="text-xs text-text-muted">{share.toFixed(1)} % skladu</span>
        </div>
        <div className="text-xs text-text-secondary">{fmtNum(c.qty)} ks</div>

        <div className="mt-2 h-1.5 rounded-full bg-border-light overflow-hidden">
          <div className={`h-full rounded-full ${tone.bar}`} style={{ width: `${pct}%` }} />
        </div>
        <div className="mt-1.5 flex justify-between text-[11px] font-semibold uppercase tracking-wide text-text-secondary">
          <span>
            Produkty: {c.productsInStock} / {c.products}
          </span>
          <span>{pct} %</span>
        </div>
        <div className="text-[11px] uppercase tracking-wide text-text-muted">
          Varianty skladem: {c.variantsInStock} / {c.variants}
        </div>
      </div>
      <Sparkline points={c.history} className="w-24 h-14 self-center shrink-0" />
    </div>
  );
}
